<style scoped>
    .item {
        margin-bottom: 10px;
        width: 100%;
        text-align: left;
        display: block;
        padding-left: 6px;
        padding-right: 30px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
    }

    .item:last-of-type {
        margin-bottom: 0;
    }

    .readonlyitem {
        margin-top: 10px;
        width: 100%;
        text-align: left;
        display: block;
        padding-right: 30px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
    }

    .readonlyitem:last-of-type {
        margin-bottom: 0;
    }

    .showAll:hover {
        font-weight: bold;
        cursor: pointer;
    }

    .clearBtn {
        opacity: 0.3;
    }

    .clearBtn:hover {
        opacity: 1;
    }
</style>
<template>
    <div>
        <div v-if="multi">
            <div v-if="editable">
                <div v-if="unimode" style="margin-bottom: 10px">
                    已选 <span style="color: #20bf64; font-weight: bold">{{ result.length }}</span> 个 <a style="color: #20bf64; font-weight: bold; margin-left: 10px" @click="resultSelector.show()">编辑</a>
                </div>
                <div v-for="(item, index) in result" :key="index" v-if="showAll || result.length <= 5 || index < 5" style="margin-bottom: 10px">
                    <div style="display: flex; position: relative">
                        <Icon @click="toClear(index)" v-if="clearable" class="hover clearBtn" type="ios-remove-circle" size="20" color="#20bf64" style="position: absolute; top: 6px; right: 6px"></Icon>
                        <Icon v-if="moveable" @click="moveDown(index)" class="hover clearBtn" type="ios-arrow-dropdown-circle" size="20" color="#32a14b" style="position: absolute; top: 6px; right: 54px"></Icon>
                        <Icon v-if="moveable" @click="moveUp(index)" class="hover clearBtn" type="ios-arrow-dropup-circle" size="20" color="#32a14b" style="position: absolute; top: 6px; right: 30px"></Icon>
                        <Button type="dashed" class="item nowrap" @click="resultSelector.show(index)">
                            <template v-if="$scopedSlots.name">
                                <slot name="name" :item="item"></slot>
                            </template>
                            <span v-else>{{ item.name }}</span>
                        </Button>
                    </div>
                </div>
                <div v-if="result.length > 5 && !showAll" style="font-size: 12px; margin-top: -8px; display: block">
                    <div class="showAll" @click="showAll = true">
                        展示全部<span v-if="!unimode">（共<span style="color: #20bf64">{{ result.length }}</span>个）</span>
                    </div>
                </div>
                <div v-if="!unimode">
                    <Button v-if="!max || result.length < max" type="dashed" class="item" @click="resultSelector.show()">+{{ label ? ` ${label}` : '' }}</Button>
                </div>
            </div>
            <div v-else>
                <div class="readonlyitem" v-for="(item, index) in result" :key="index" v-if="showAll || result.length <= 5 || index < 5">
                    <template v-if="$scopedSlots.name">
                        <slot name="name" :item="item"></slot>
                    </template>
                    <span v-else>{{ item.name }}</span>
                </div>
                <div v-if="result.length > 5 && !showAll" style="font-size: 12px; margin-top: -8px; display: block">
                    <div class="showAll" @click="showAll = true">
                        展示全部（共<span style="color: #20bf64">{{ result.length }}</span>个）
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="editable">
                <div v-if="result" style="display: flex; position: relative">
                    <Icon @click="toClear()" v-if="clearable" class="hover clearBtn" type="ios-remove-circle" size="20" color="#20bf64" style="position: absolute; top: 6px; right: 6px"></Icon>
                    <Button type="dashed" class="item" @click="resultSelector.show()">
                        <template v-if="$scopedSlots.name">
                            <slot name="name" :item="item"></slot>
                        </template>
                        <span v-else>{{ result.name }}</span>
                    </Button>
                </div>
                <Button v-else type="dashed" class="item" @click="resultSelector.show()">+{{ label ? ` ${label}` : '' }}</Button>
            </div>
            <div v-else class="readonlyitem">
                <template v-if="$scopedSlots.name">
                    <slot name="name" :item="item"></slot>
                </template>
                <span v-else>{{ result ? result.name : '' }}</span>
            </div>
        </div>

        <Modal v-model="resultSelector.display" class="nopadding" footer-hide :width="useMendianSelector ? 1200 : 800">
            <template v-if="resultSelector.display">
                <MendianSelector v-if="datatype == 'jigou' && useMendianSelector" :current="current" v-on:cancel="resultSelector.display = false" v-on:mendianSelected="resultSelector.confirm"></MendianSelector>
                <DataSelector v-else :options="resultSelector.options" :nopage="nopage" v-on:cancel="resultSelector.display = false" v-on:confirm="resultSelector.confirm"></DataSelector>
            </template>
        </Modal>
    </div>
</template>
<script>
    export default {
        props: {
            unimode: {
                type: Boolean,
                default: false,
            },
            moveable: {
                type: Boolean,
                default: true,
            },
            datatype: {
                type: String,
            },
            current: {
                type: [Object, Array],
                default: null,
            },
            multi: {
                type: Boolean,
                default: false,
            },
            all: {
                type: Boolean,
                default: false,
            },
            max: {
                type: Number,
                default: null,
            },
            editable: {
                type: Boolean,
                default: true,
            },
            clearable: {
                type: Boolean,
                default: true,
            },
            label: {
                type: String,
            },
            loadurl: {
                type: String,
            },
            disableItem: {
                type: Function, //在选择时，部分Item将被动态禁用
            },
            useMendianSelector: {
                type: Boolean,
                default: false,
            },
            fields: Object,
            query: Object,
            columns: Array,
            nopage: {
                type: Boolean,
                default: false,
            },
        },
        watch: {
            current(value) {
                if (value) {
                    this.result = this.copy(value)
                    if (this.guanxiajigou) {
                        let session = this.$store.session
                        this.result_not_in_guanxia = this.result.filter((o) => !session.zhanghao.guanxiajigous.some((j) => j._id == o._id))
                        this.result = this.result.filter((o) => session.zhanghao.guanxiajigous.some((j) => j._id == o._id))
                    }
                } else {
                    if (this.multi) {
                        this.result = []
                    } else {
                        this.result = null
                    }
                }
            },
        },
        data() {
            return {
                guanxiajigou: false,
                result_not_in_guanxia: [],
                showAll: false,
                loading: false,
                result: this.multi ? [] : null,
                resultSelector: {
                    display: false,
                    index: null,
                    _replace: false,
                    options: null,
                    show: (index) => {
                        this.resultSelector.options = {
                            datatype: this.datatype,
                            multi: this.multi,
                            max: this.max,
                            all: this.all,
                            current: this.unimode ? this.result : [],
                            loadurl: this.loadurl,
                            disableItem: this.disableItem,
                            placeholder: '搜索',
                            ...this.getDataSetting(),
                        }
                        if (index !== undefined) {
                            this.resultSelector.index = index
                            this.resultSelector._replace = true
                        } else {
                            this.resultSelector.index = null
                        }
                        this.resultSelector.display = true
                    },
                    confirm: (value) => {
                        if (this.multi && !this.unimode) {
                            if (this.max && this.result.length >= this.max) return
                            if (this.resultSelector.index !== null) {
                                this.result.splice(this.resultSelector.index, 1)
                                value = value.reverse()
                                for (let item of value) {
                                    this.result.splice(this.resultSelector.index, 0, item)
                                }
                            } else {
                                this.result = this.result.concat(value)
                            }
                        } else {
                            this.result = value
                        }
                        this.loading = false
                        this.resultSelector.display = false
                        this.confirm()
                    },
                },
            }
        },
        mounted() {
            // setTimeout(() => { this.init() }, 100)
            this.init()
        },
        methods: {
            moveUp(index) {
                if (index == 0) {
                    return
                }
                let temp = this.result[index - 1]
                this.result[index - 1] = this.result[index]
                this.result[index] = temp
                this.confirm()
            },
            moveDown(index) {
                if (index == this.result.length - 1) {
                    return
                }
                let temp = this.result[index + 1]
                this.result[index + 1] = this.result[index]
                this.result[index] = temp
                this.confirm()
            },
            init() {
                if (this.query && this.query.guanxiajigou == true) {
                    this.guanxiajigou = true
                }
                if (this.current) {
                    let result = this.copy(this.current)
                    if (this.guanxiajigou) {
                        let session = this.$store.session
                        this.result_not_in_guanxia = result.filter((o) => !session.zhanghao.guanxiajigous.some((j) => j._id == o._id))
                        this.result = result.filter((o) => session.zhanghao.guanxiajigous.some((j) => j._id == o._id))
                    } else {
                        this.result = result
                    }
                }
            },
            confirm() {
                let result = this.copy(this.result)
                if (this.result_not_in_guanxia && this.result_not_in_guanxia.length > 0) {
                    result = result.concat(this.result_not_in_guanxia)
                }
                this.$emit('confirm', result)
            },
            toClear(index) {
                if (this.multi) {
                    this.result.splice(index, 1)
                } else {
                    this.result = null
                }
                this.confirm()
            },
            getDataSetting() {
                let { datatype, name, fields, query, columns } = this
                if (datatype == 'jigou' || datatype == 'wupin') {
                    if (!columns) {
                        columns = [{
                                title: '名称',
                                minWidth: 200,
                                render: (h, params) => {
                                    return h('div', params.row.name)
                                },
                            },
                            {
                                title: '编码',
                                minWidth: 100,
                                render: (h, params) => {
                                    return h('div', params.row.code)
                                },
                            },
                            // {
                            //     title: '最后更新时间',
                            //     minWidth: 180,
                            //     render: (h, params) => {
                            //         return h('div', this.moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss'))
                            //     }
                            // },
                        ]
                    }
                } else if (datatype == 'cangku') {
                    if (!columns) {
                        columns = [{
                                title: '名称',
                                minWidth: 200,
                                render: (h, params) => {
                                    return h('div', params.row.name)
                                },
                            },
                            {
                                title: '编码',
                                minWidth: 100,
                                render: (h, params) => {
                                    return h('div', params.row.code)
                                },
                            },
                            {
                                title: '所属机构',
                                minWidth: 100,
                                render: (h, params) => {
                                    return h('div', params.row.jigou.name)
                                },
                            },
                            // {
                            //     title: '最后更新时间',
                            //     minWidth: 180,
                            //     render: (h, params) => {
                            //         return h('div', this.moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss'))
                            //     }
                            // },
                        ]
                    }
                } else if (datatype == 'coupon') {
                    if (!columns) {
                        columns = [{
                                title: '名称',
                                minWidth: 200,
                                render: (h, params) => {
                                    return h('div', params.row.name)
                                },
                            },
                            {
                                title: '分组',
                                minWidth: 100,
                                render: (h, params) => {
                                    return h('div', params.row.group)
                                },
                            },
                            {
                                title: '类型',
                                minWidth: 80,
                                render: (h, params) => {
                                    return h('div', params.row.type)
                                },
                            },
                            {
                                title: '价值',
                                key: 'jiazhi',
                                minWidth: 80,
                            },
                            {
                                title: '最后更新时间',
                                minWidth: 180,
                                render: (h, params) => {
                                    return h('div', this.moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss'))
                                },
                            },
                        ]
                    }
                } else if (datatype == 'jiagongpin') {
                    if (!columns) {
                        columns = [{
                                title: '名称',
                                minWidth: 200,
                                render: (h, params) => {
                                    // let divs = []
                                    return h('div', { class: 'df' }, params.row.wupin.name)
                                },
                            },
                            {
                                title: '供货机构',
                                minWidth: 200,
                                render: (h, params) => {
                                    // let divs = []
                                    return h('div', { class: 'df' }, params.row.jigou.name)
                                },
                            },
                            {
                                title: '加工间',
                                minWidth: 200,
                                render: (h, params) => {
                                    // let divs = []
                                    return h('div', { class: 'df' }, params.row.jiagongjian.name)
                                },
                            },
                            {
                                title: '创建时间',
                                minWidth: 180,
                                render: (h, params) => {
                                    return h('div', this.moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss'))
                                },
                            },
                        ]
                    }
                } else {
                    if (!columns) {
                        columns = [{
                                title: '名称',
                                minWidth: 200,
                                render: (h, params) => {
                                    return h('div', params.row.name)
                                },
                            },
                            // {
                            //     title: '最后更新时间',
                            //     minWidth: 180,
                            //     render: (h, params) => {
                            //         return h('div', this.moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss'))
                            //     }
                            // },
                        ]
                    }
                }
                return {
                    name,
                    fields,
                    query,
                    columns,
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/common/CustomData.vue?7319258a